"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var checkoutStorePopup_1 = require("./checkoutStorePopup");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.PopupLoadEventNames.CheckoutStorePopup] = checkoutStorePopup_1.checkoutStorePopupClickCreator,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
